// How a demand line is fulfilled. Mirrors TMSWeb.Common.Constants.FulfilmentRoutes - the
// values are stored on the demand, so the two must stay in step.
export enum FulfilmentRoutes {
  localStock = 'LocalStock',
  viaTransfer = 'ViaTransfer',
  direct = 'Direct',
}

// The route as a HUMAN reads it. The stored values are single words because they are
// identifiers, but nobody wants "ViaTransfer" in a grid cell. Kept next to the enum so the
// two can never drift, and used via a grid valueGetter rather than a valueFormatter - the
// shared cell renderer reads params.value, so a formatter would be ignored.
export function fulfilmentRouteName(route: string | undefined | null): string {
  switch (route) {
    case FulfilmentRoutes.localStock:
      return $localize`Local Stock`;
    case FulfilmentRoutes.viaTransfer:
      return $localize`Via Transfer`;
    case FulfilmentRoutes.direct:
      return $localize`Direct`;
    default:
      // Anything unrecognised shows as stored rather than vanishing.
      return route ?? '';
  }
}

// Grid column options for a route field - spread into gridService.text.
export function routeColumnOptions(field = 'fulfilmentRoute') {
  return { valueGetter: (params: { data?: Record<string, string> }) => fulfilmentRouteName(params.data?.[field]) };
}
